import { useEffect, useState, RefObject } from 'react';
import { checkVideoOrientation } from '../helpers/checkVideoOrientation';

const useVideoOrientation = (videoRef: RefObject<HTMLVideoElement>) => {
  const [isVideoLandscape, setIsVideoLandscape] = useState(true);

  useEffect(() => {
    const videoElement = videoRef.current;

    const handleLoadedMetadata = (event: Event) => {
      const video = event.target as HTMLVideoElement;
      setIsVideoLandscape(checkVideoOrientation(video) === 'landscape');
    };

    if (videoElement && videoElement.readyState >= 1) {
      setIsVideoLandscape(checkVideoOrientation(videoElement) === 'landscape');
    } else {
      videoElement?.addEventListener('loadedmetadata', handleLoadedMetadata);
    }

    return () => {
      videoElement?.removeEventListener('loadedmetadata', handleLoadedMetadata);
    };
  }, [videoRef]);

  return isVideoLandscape;
};

export default useVideoOrientation;